module.exports = __webpack_public_path__ + "static/media/bt-cerrar-ayuda.3fc3d49f.svg";